import { useEffect } from 'react';
import useMountedState from 'react-use/lib/useMountedState';
import { useInstanceId } from '../../context/instance/instanceContext';
import { addFpsSample, getFpsSample } from '../../utils/fpsUtils';
export const FpsSampler = () => {
    const isMounted = useMountedState();
    const instanceId = useInstanceId();
    useEffect(() => {
        async function effect() {
            if (instanceId !== 0) {
                return;
            }
            const fps = await getFpsSample();
            if (fps === null) {
                return;
            }
            if (!isMounted()) {
                return;
            }
            // scene is still mounted, consider sample valid
            addFpsSample(fps);
        }
        effect();
    }, [instanceId, isMounted]);
    return null;
};
